export default __webpack_public_path__ + "static/media/er.80f107b7.png";